export default "__VITE_ASSET__078914e1__"